import * as fromBckpDashboardActions from './dashboard/dashboard.actions';
import * as fromBckpJobsActions from './jobs/jobs.actions';
import * as fromBckpServersServActions from './servers/serv/serv.actions';
import * as fromBckpServersHeatActions from './servers/heat/heat.actions';
import * as fromBckpOptionsActions from './common/options/options.actions';
import * as fromBckpCapacitiesActions from './capacities/capacities.actions';
import * as fromBckpPoliciesActions from './policies/policies.actions';
import * as fromBckpCopiesActions from './copies/copies.actions';
import * as fromBckpVbrDashboardActions from './veeam/vbr/vbr-dashboard/vbr-dashboard.actions';
import * as fromBckpVboDashboardActions from './veeam/vbo/vbo-dashboard/vbo-dashboard.actions';
export {
    getBckpDashboardLastSession, getBckpDashboardLastSessionIsDataValid,
    getBckpDashboardStatusPerRange, getBckpDashboardStatusPerRangeIsDataValid,
    getBckpDashboardTicketing,
    getBckpDashboardStatusPerPolicyType, getBckpDashboardStatusPerPolicyTypeIsDataValid,
    getBckpDashboardVariations, getBckpDashboardVariationsIsDataValid,
    getBckpDashboardTotalCapacity, getBckpDashboardTotalCapacityIsDataValid,
    getBckpDashboardCountServers, getBckpDashboardCountServersIsDataValid,

    getBckpJobsQueryString, getBckpJobsODataReady, getBckpJobsExportQueryString, getBckpJobsSinceUntil,
    getAllDetailedJobs, getBckpJobDetailsById, getBckpSelectedJobDetails, getBckpJobsDetailsSelectedJob,
    getAllJobs, getBckpJobsFilter, getBckpJobsLoadingStatus, getBckpJobsEndReached,
    getQuickSearchedJobs, getPipelinedJobs, getBckpJobsLoadedStatus, getBckpJobsEmptyStatus, getBckpJobsOupsStatus,
    getBckpJobsNbLoaded, getAllJobsByIdentifier, getBckpVbrJobsODataReady, getBckpVbrJobsQueryString,
    getBckpJobsStatsQueryString, getBckpJobsStats,

    getBckpCapacitiesLoadingStatus, getBckpCapacitiesODataReady, getBckpCapacitiesArraySinceUntil, getBckpCapacitiesArrayRangeSinceUntil,
    getChargedCapacities, getBckpCapacitiesPolicies, getBckpCapacitiesGrandTotal,
    getBckpCapacitiesFilter, getBckpCapacitiesExportQueryString, getQuickSearchedCapacities,
    getPipelinedCapacities, getBckpCapacitiesLoadedStatus, getBckpCapacitiesIsEmptyStatus,

    getBckpVbrDashboardStatusPerRange, getBckpVbrDashboardStatusPerRangeIsDataValid, getBckpVbrDashboardLastSession,
    getBckpVbrDashboardLastSessionIsDataValid, getBckpVbrDashboardCountServers, getBckpVbrDashboardCountServersIsDataValid,
    getBckpVbrDashboardTotalCapacity, getBckpVbrDashboardTicketing, getBckpVbrDashboardVariations, getBckpVbrDashboardVariationsIsDataValid,
    getPipelinedVbrJobs, getBckpVbrJobsFilter, getBckpVbrJobsExportQueryString,
    getBckpVbrJobsLoadingStatus, getBckpVbrJobsLoadedStatus, getBckpVbrJobsOupsStatus, getBckpVbrJobsEndReached,

    getBckpVboDashboardStatusPerRange, getBckpVboDashboardStatusPerRangeIsDataValid, getBckpVboDashboardLastSession,
    getBckpVboDashboardLastSessionIsDataValid, getBckpVboDashboardCountServers, getBckpVboDashboardCountServersIsDataValid,
    getBckpVboDashboardTotalCapacity, getBckpVboDashboardTicketing, getBckpVboDashboardVariations, getBckpVboDashboardVariationsIsDataValid
} from './bckp.reducer';

// #region Servers
export {
    getBckpServersServQueryString,
    getServersServIsDataValid, getBckpServersServEmptyStatus, getBckpServersServOupsStatus, getBckpServersServLoadingStatus, getBckpServersServLoadedStatus,
    getBckpServersServFilter,
    getBckpServersServExportQueryString,
    getPipelinedServersServ,
    serversServSelectedImages
} from './servers/bckp-servers.selectors';
export {
    getBckpServersHeatQueryString,
    getBckpServersHeatIsDataValid, getBckpServersHeatEmptyStatus, getBckpServersHeatOupsStatus, getBckpServersHeatLoadingStatus, getBckpServersHeatLoadedStatus,
    getBckpServersHeatFilter,
    getServersHeatJobsQs, getServersHeatJobs, getServersHeatJobsNbLoaded,
    getBckpServersHeatIssuesOnlyState, getBckpServersHeatExportQueryString
} from './servers/heat/heat.selectors';
// #endregion

// Policies
export {
    getAllPolicies, getBckpPoliciesLoadingStatus,
    getBckpPolicyDetailsById, getAllDetailedPolicies, getBckpSelectedPolicyDetails,
    getPoliciesFilter, getBckpPoliciesOupsStatus, getBckpPoliciesEmptyStatus,
    getBckpPoliciesExportQueryString, getQuickSearchedPolicies, getPipelinedPolicies,
    getBckpPoliciesLoadedStatus,

} from './policies/policies-selectors';
// Copies
export {
    getAllCopiesCurr, getCopiesCurrIsDataValid,
    getCopiesCurrIsEmpty, getCopiesCurrIsLoaded,
    getCopiesCurrIsLoading, getCopiesCurrIsOups,
    getBckpCopiesCurrFilter,
    getQuickSearchedCopiesCurr, getPipelinedCopiesCurr,

    getAllCopiesEvol, getCopiesEvolQueryString,
    getCopiesEvolIsDataValid, getCopiesEvolIsLoading,
    getCopiesEvolIsOups, getCopiesEvolIsLoaded,
    getBckpCopiesEvolFilter, getCopiesEvolIsEmpty
} from './bckp-copies.reducer';
// Options
export {
    getBckpOptionsMastersIsDataValid, getMastersOptions,
    getBckpOptionsServersIsDataValid, getServersOptions,
    getBckpOptionsServerShortsIsDataValid, getServerShortsOptions,
    getBckpOptionsPoliciesIsDataValid, getPoliciesOptions,
    getBckpOptionsPolicyTypesIsDataValid, getPolicyTypesOptions,

    getBckpOptionsCopiesServersIsDataValid, getCopiesServersOptions,
    getBckpOptionsCopiesPoliciesIsDataValid, getCopiesPoliciesOptions,
    getBckpOptionsCopiesResidencesIsDataValid, getCopiesResidencesOptions,
    getBckpOptionsCopiesSLPIsDataValid, getCopiesSLPOptions
} from './bckp-options.reducer';

export { BckpStoreModule } from './bckp-store.module';
export {
    fromBckpDashboardActions as BckpDashboardStoreActions,
    fromBckpJobsActions as BckpJobsStoreActions,
    fromBckpServersServActions as BckpServersServStoreActions,
    fromBckpServersHeatActions as BckpServersHeatStoreActions,
    fromBckpOptionsActions as BckpOptionsStoreActions,
    fromBckpCapacitiesActions as BckpCapacitiesStoreActions,
    fromBckpPoliciesActions as BckpPoliciesStoreActions,
    fromBckpCopiesActions as BckpCopiesActions,
    fromBckpVbrDashboardActions as BckpVbrDashboardStoreActions,
    fromBckpVboDashboardActions as BckpVboDashboardStoreActions
};
